import { OptionType } from '@pylot-data/hooks/product/use-product-ui'
import type {
    ConfigurableProductOptionsValues,
    ColorSwatchData,
    ImageSwatchData,
    TextSwatchData,
    Maybe
} from '@pylot-data/pylotschema'

export const COLOR_SWATCH_DATA = 'ColorSwatchData'
export const TEXT_SWATCH_DATA = 'TextSwatchData'
export const IMAGE_SWATCH_DATA = 'ImageSwatchData'

export const getOptionType = (
    value?: Maybe<ConfigurableProductOptionsValues>
): OptionType | null => {
    if (!value) return null

    switch (
        (value.swatch_data as
            | TextSwatchData
            | ColorSwatchData
            | ImageSwatchData)?.__typename
    ) {
        case undefined:
            return OptionType.Dropdown
        case COLOR_SWATCH_DATA:
            return OptionType.VisualSwatch
        case TEXT_SWATCH_DATA:
            return OptionType.TextSwatch
        default:
            return OptionType.Other
    }
}
